// extracted by mini-css-extract-plugin
module.exports = {"FormTitle":"CallerDetails_FormTitle_1WKJR","formLayout":"CallerDetails_formLayout_2iBNH","box":"CallerDetails_box_2kLNr"};